/**
 * Created by hp on 2017/8/21.
 */
import React, {Component} from 'react';
import noSource from '../../images/ban-no-item.png';

class WKNoData extends Component {
    render() {
        const {text = "暂无数据"} = this.props;
        return(
            <div className="wk-no-source wk-screen-center">
                <div className="source-img">
                    <img src={noSource}/>
                </div>
                <p className="source-text">{text}</p>
            </div>
        )
    }
}

export default WKNoData;


// WEBPACK FOOTER //
// ./src/components/wk/WKNoData.js